import { z } from "zod";

export const allCategories = [
  "Royalty-free",
  "Saved",
  "Instruments",
  "My",
  "Mixed",
] as const;

export const allCategoriesSpec = z.enum(allCategories);

export type Category = z.infer<typeof allCategoriesSpec>;

export const allGenderFilters = ["Male", "Female"] as const;
export const allGenderFiltersSpec = z.enum(allGenderFilters);

export type GenderFilter = z.infer<typeof allGenderFiltersSpec>;

export const allGenreFilters = [
  "Pop",
  "Dance",
  "Hip Hop",
  "RnB",
  "Unprocessed",
  "Indie",
  "Rock",
  "Soul",
  "Reggae",
  "Afrobeat",
  "Folk",
  "Country",
  "Blues",
  "Jazz",
  "Funk",
  "Disco",
  "Alternative",
  "Punk",
  "Ethereal",
  "Latin",
  "Spoken Word",
  "Soundtrack",
  "Theatrical",
  "Ballads",
  "Classical",
  "Growl",
  "Mature",
  "Falsetto",
  "Deep",
  "Belting",
  "Gritty",
  "Airy",
  "Kids",
] as const;

export const allGenreFiltersSpec = z.enum(allGenreFilters);
export type GenreFilter = z.infer<typeof allGenreFiltersSpec>;

export const allPitchRangeCategories = [
  "Bass",
  "Low",
  "Mid",
  "High",
  "Very high",
] as const;

export const allPitchRangeCategoriesSpec = z.enum(allPitchRangeCategories);
export type PitchRangeCategory = z.infer<typeof allPitchRangeCategoriesSpec>;
